<template>
  <v-alert
    v-model="alert"
    color="orange-lighten-1"
    variant="tonal"
    class="mx-3 my-5"
  >
    <div class="d-flex">
      <v-icon icon="mdi-rocket-launch-outline" class="me-2" />
      <span>Notifikasi Tugas</span>
      <v-spacer></v-spacer>
      <v-icon icon="mdi-close my-auto" size="x-small" @click="alert = false" />
    </div>
    <div class="text-black text-caption my-2">
      Beberapa tugas yang wajib Anda kerjakan minggu ini
    </div>
    <v-card
      variant="outlined"
      color="black"
      class="pa-2 mb-2"
      @click="dialog = true"
    >
      <div class="d-flex justify-space-between">
        <span class="text-caption">
          Tugas Evaluasi Akademik
        </span>
        <v-icon
          icon="mdi-arrow-right-bold-circle-outline"
          size="x-small"
          class="my-auto"
        />
      </div>
    </v-card>
  </v-alert>
  <v-dialog :model-value="dialog" max-width="600">
    <v-card>
      <v-card-title>
        <v-row no-gutters align="center">
          <span>Tugas Evaluasi Akademik</span>
          <v-spacer></v-spacer>
          <v-btn
            icon="mdi-close"
            size="small"
            variant="text"
            @click="dialog = false"
          ></v-btn>
        </v-row>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text>
        <div>
          <div class="text-overline mb-2">Deskripsi Tugas</div>
          <p>
            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed vel sapien
            vel justo pulvinar semper vel in velit. Donec facilisis, nunc vitae
            facilisis placerat, mauris ex hendrerit neque, in fringilla purus
            ligula in neque. Donec in nulla vel ligula semper consectetur. Sed
            ultricies velit sit amet nisi lobortis, id condimentum velit scelerisque.
            Aliquam erat volutpat.
          </p>
          <v-chip size="small" color="red" class="mt-3">
            Batas akhir: 17-08-2024, 23:59
          </v-chip>
          <v-file-input label="Upload Tugas" class="mt-3"></v-file-input>
        </div>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          text="Tutup"
          class="text-none border"
          variant="flat"
          @click="dialog = false"
        />
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  data() {
    return {
      alert: true,
      dialog: false,
    }
  }
}
</script>